export const institution = 'Institution';

export const institutionSelector = {
  label: institution,
  hint: institution,
  createInstitution: 'Create Institution',
  noDataText: 'No institutions found',
};
